<template>
  <div class="drawer">
    <div class="drawer-container">
      <div class="drawer-content with-footer">
        <el-form
          ref="userForm"
          :model="user"
          label-width="80px"
          size="small"
          class="box"
        >
          <div>
            <el-row>
              <el-col :span="12">
                <el-form-item
                  :label="$t('menu.authTemplates')"
                  :prop="'shopId'"
                >
                  <el-select
                    size="small"
                    v-model="authTemplateId"
                    @change="selectTemplate"
                  >
                    <el-option
                      v-for="authTemplate in authTemplates"
                      :key="authTemplate.id"
                      :label="authTemplate.name"
                      :value="authTemplate.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label-width="0px">
                  <i
                    class="el-icon-setting blue"
                    @click="$router.push('/set/perference/auth-templates')"
                  >
                  </i>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div
            v-for="(sys, index) of permissions"
            :key="sys.name"
            class="pd10-lr"
            style="border-bottom: 1px solid #e6ebf5"
          >
            <div
              style="height: 40px; line-height: 40px; clear：both"
              @click="expend(sys, index)"
            >
              <span class="float-left">
                {{ sys.label }}
              </span>
              <span class="float-right">
                <i
                  v-if="sys.show"
                  :class="
                    sys.show == true
                      ? 'el-icon-arrow-down'
                      : 'el-icon-arrow-right'
                  "
                />
              </span>
            </div>
            <div v-if="sys.show" class="pd10-lr">
              <div v-for="item of sys.items" :key="item.name" class="mgb15">
                <div class="mgb10 grey-dark">
                  <el-checkbox
                    v-model="checkedPermissions"
                    :label="item.name"
                    @change="checkPermission(item)"
                  >
                    {{ item.label }}
                  </el-checkbox>
                </div>
                <el-row class="pd20-lr" :gutter="10">
                  <el-col
                    v-for="i of item.items"
                    :key="i.name"
                    :span="8"
                    class="mgb10"
                  >
                    <el-checkbox
                      v-model="checkedAuth"
                      :label="i.name"
                      class="font16"
                    >
                      {{ i.label }}
                    </el-checkbox>
                    <div v-if="i.desc != null" class="mgt5 font14 grey-shallow">
                      {{ i.descc }}
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <div class="drawer-footer">
      <el-button
        type="primary"
        size="small"
        plain
        :loading="saveDoing"
        @click="saveSubmit('submit')"
        >{{ $t("text.submit") }}</el-button
      >
      <el-button
        type="success"
        size="small"
        plain
        :loading="saveDoing"
        @click="saveSubmit('submitAndTemplate')"
        >{{ $t("text.submit") }}并保存模版</el-button
      >
    </div>

    <!-- 权限模版 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('menu.authTemplates')"
      :visible.sync="authTemplateDF"
      width="30%"
      :close-on-click-modal="false"
    >
      <el-form
        ref="authTemplateObjForm"
        :model="authTemplateObj"
        label-width="60px"
      >
        <el-form-item
          :label="$t('text.name')"
          :prop="'name'"
          :rules="[
            {
              required: true,
              validator: validateAuthTemplateName,
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            size="small"
            v-model.trim="authTemplateObj.name"
            :placeholder="$t('text.name')"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="authTemplateDoing"
          size="small"
          @click="authTemplateSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="authTemplateDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
import { page } from "@/utils/mixins.js";
import Permit from "@/utils/permit.js";
import Util from "@/utils/index.js";
import User from "@/api/user.js";
import Shop from "@/api/shop.js";
import AuthTemplate from "@/api/authTemplate.js";
import Subject from "@/api/subject.js";
import UserAuth from "@/api/userAuth.js";
import Phase from "@/api/phase.js";

export default {
  props: {
    id: Number,
  },
  mixins: [page],
  data() {
    var validateAuthTemplateName = (rule, value, callback) => {
      const self = this;
      if (value == null) {
        callback(new Error(self.$t("rules.required", [this.$t("text.name")])));
        return;
      }
      AuthTemplate.findByName({ name: value }).then(function (res) {
        if (res.data.code == 200) {
          callback(new Error(self.$t("rules.exist", [self.$t("text.name")])));
        } else {
          callback();
        }
      });
    };
    return {
      Util: Util,
      permissions: Permit.permissions(),
      user: {},
      checkedAuth: [],
      authTemplates: [],

      subjectsJson: null,
      phasesJson: null,

      checkedPermissions: [],
      saveDoing: false,
      //
      validateAuthTemplateName: validateAuthTemplateName,
      authTemplateDF: false,
      authTemplateObj: {
        name: null,
        authJsons: null,
      },
      authTemplateDoing: false,
      //
      authTemplateId: null,
    };
  },
  created() {
    const self = this;
    self.loadingStart();
    self.authTemplate = null;
    User.findById(self.id).then(function (res) {
      if (res.data.code === 200) {
        self.user = res.data.entity;
        self.checkedAuth = JSON.parse(self.user.actionsJson || "[]");
        self.getAuthTemplates();
        if (self.Permit.extendModels().includes("mms")) {
          self.getMmsAuth();
        }
        if (self.Permit.extendModels().includes("mes")) {
          self.getMesAuth();
        }
      } else {
        self.sysError();
      }
      self.loadingEnd();
    });
  },
  methods: {
    selectTemplate() {
      const authTemplate = this.authTemplates.find(
        (at) => at.id == this.authTemplateId
      );
      this.checkedAuth = JSON.parse(authTemplate.authJsons || "[]");
    },
    expend(sys, index) {
      this.permissions[index].show = !this.permissions[index].show;
    },
    checkPermission(item) {
      const self = this;
      const currentPermissionAuths = item.items.map((i) => i.name);
      if (self.checkedPermissions.indexOf(item.name) !== -1) {
        for (const currentPermissionAuth of currentPermissionAuths) {
          if (self.checkedAuth.indexOf(currentPermissionAuth) === -1) {
            self.checkedAuth.push(currentPermissionAuth);
          }
        }
      } else {
        for (const currentPermissionAuth of currentPermissionAuths) {
          if (self.checkedAuth.indexOf(currentPermissionAuth) !== -1) {
            self.checkedAuth.splice(
              self.checkedAuth.indexOf(currentPermissionAuth),
              1
            );
          }
        }
      }
    },

    getAuthTemplates() {
      const self = this;
      AuthTemplate.findByTenantId().then(function (res) {
        if (res.status === 200) {
          self.authTemplates = res.data;
        } else {
          self.sysError();
        }
      });
    },
    getMmsAuth() {
      const self = this;
      UserAuth.findByIdMms(self.id).then(function (userAuths) {
        if (userAuths.data.code === 200) {
          const userAuthsMms = userAuths.data.entity;
          self.checkedAuth = self.checkedAuth.concat(
            JSON.parse(userAuthsMms.actionsJson || "[]")
          );
          self.subjectsJson = userAuthsMms.subjectsJson;
        } else {
          // 其他是没有授权的
        }
      });
    },
    getMesAuth() {
      const self = this;
      UserAuth.findByIdMes(self.id).then(function (userAuths) {
        if (userAuths.data.code === 200) {
          const userAuthsMes = userAuths.data.entity;
          self.checkedAuth = self.checkedAuth.concat(
            JSON.parse(userAuthsMes.actionsJson || "[]")
          );
          self.phasesJson = userAuthsMes.phasesJson;
        } else {
          // 其他是没有授权的
        }
      });
    },

    saveSubmit(type) {
      const self = this;
      // console.log("======", self.checkedAuth);
      if (type == "submitAndTemplate") {
        self.authTemplateDF = true;
        self.authTemplateObj.authJsons = JSON.stringify(self.checkedAuth);
        return;
      }
      self.saveSubmitFun();
    },
    authTemplateSubmit() {
      const self = this;
      self.$refs.authTemplateObjForm.validate((valid) => {
        if (valid) {
          self.authTemplateDoing = true;
          AuthTemplate.create(self.authTemplateObj).then(function (res) {
            self.authTemplateDoing = false;
            self.authTemplateDF = false;
            if (res.status === 200) {
              self.saveSubmitFun();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    saveSubmitFun() {
      const self = this;
      // console.log("======", self.checkedAuth);
      self.$refs.userForm.validate((valid) => {
        if (valid) {
          self.userActionsJY = [];
          self.userActionsMms = [];
          self.userActionsMes = [];

          // 权限
          for (const i in self.checkedAuth) {
            if (
              !self.Permit.sysPermits("mms").includes(self.checkedAuth[i]) &&
              !self.Permit.sysPermits("mes").includes(self.checkedAuth[i])
            ) {
              self.userActionsJY.push(self.checkedAuth[i]);
            }
            if (self.Permit.sysPermits("mms").includes(self.checkedAuth[i])) {
              self.userActionsMms.push(self.checkedAuth[i]);
            }
            if (self.Permit.sysPermits("mes").includes(self.checkedAuth[i])) {
              self.userActionsMes.push(self.checkedAuth[i]);
            }
          }
          let obj = {
            actionsJson: JSON.stringify(self.userActionsJY),
          };

          self.saveDoing = true;
          User.updateActions(self.id, obj).then(function (res) {
            self.saveDoing = false;
            if (res.status === 200) {
              if (self.Permit.extendModels().includes("mms")) {
                self.saveSubmitMmsUserActions();
              }
              if (self.Permit.extendModels().includes("mes")) {
                self.saveSubmitMesUserActions();
              }
              self.sysResult(res.data);
              self.$emit("updateInfo");
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    saveSubmitMmsUserActions() {
      const self = this;
      const obj = {
        id: self.user.id,
        subjectsJson: self.subjectsJson,
        actionsJson: JSON.stringify(self.userActionsMms),
      };
      UserAuth.createMms(obj).then(function (res) {
        if (res.status === 200) {
          // self.$message({
          //   message: self.$t("prompt.authSuccess"),
          //   type: "success"
          // });
        } else {
          self.sysError();
        }
      });
    },
    saveSubmitMesUserActions() {
      const self = this;
      const obj = {
        id: self.user.id,
        phasesJson: self.phasesJson,
        actionsJson: JSON.stringify(self.userActionsMes),
      };
      UserAuth.createMes(obj).then(function (res) {
        if (res.status === 200) {
          // self.$message({
          //   message: self.$t("prompt.authSuccess"),
          //   type: "success"
          // });
        } else {
          self.sysError();
        }
      });
    },
  },
};
</script>